<template>
  <div class="h-100">
    <div class="h-100">
      <div class="match-card match-card__match text-center">
        <div class="match-card__desc">
          <div class="title">

            {{ trans.get('pages:match_game.match_card.header') }}<span>!</span>
          </div>
          <div class="desc">
            Du hast ein <span>Match!</span>
          </div>
        </div>
        <div class="avatar-with-avatar">
          <div class="avatar-with-avatar__first" :style="{'background-image':'url(' + user.web_avatar_url + ')'}"></div>
          <div class="avatar-with-avatar__second" :style="{'background-image':'url(' + current.profile.avatar_url + ')'}"></div>
        </div>

        <div class="match-card__person-info">
          <p>{{ current.profile.name }}, {{ current.profile.age }}</p>
        </div>

        <div class="match-card__form">
          <div class="match-card__input">

            <!-- <input v-model="message" type="text" class="input--tertiary" minlength="3" :placeholder="trans.get('pages:match_game.match_card.send_placeholder')"> -->
            <input v-model="message" type="text" class="input--tertiary" minlength="3" :placeholder="'Sag &quot;Hallo&quot;'">
          </div>

          <button v-on:click="sendMessage()" class="button button--primary">
            {{ trans.get('pages:match_game.match_card.send_button') }}
          </button>
          <!--                <button v-on:click="sendMessage()" class="button button__fill button__fill&#45;&#45;cta">{{ trans.get('pages:match_game.match_card.send_button') }}</button>-->

          <error-component :errors="formErrors" field='message'></error-component>
        </div>
      </div>
      <div class="match-card__button">
        <button v-on:click="emitNext()" class="button button__text-icon">
          <span>{{ trans.get('pages:match_game.match_card.keep_looking_button') }}</span>
          <i class="demo-icon icon-next"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'LikeCard',
  props: {
    value: Object,
    current: Object,
  },
  data() {
    return {
      responseMessage: null,
      message: null,
      formErrors: {},
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  methods: {
    emitNext() {
      this.$emit('input', { visible: false, });
      this.$emit('next', 'NEXT');
      this.$store.dispatch('profiles/loadMatches');
    },
    sendMessage() {
      return axios.post(zRoute('ajax.match_game.love_message', this.current.profile.id), {
        message: this.message,
      }).then(response => {
        if (response.data.status === 'success') {
          this.emitNext();
        }

        this.responseMessage = response.data.message;
      }).catch(error => {
        this.formErrors = error.response.data.errors;
        this.responseMessage = error.response.data.message;
        this.$emit('error');
      });
    },
  },
  mounted() {
  }
};
</script>


